declare const I18n;

import React from "react";

type LearnersTabsProps = {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
};

const LearnersTabs: React.FC<LearnersTabsProps> = ({ currentTab, setCurrentTab }) => {
  return (
    <ul className="nav nav-tabs" style={{ paddingBottom: 0 }}>
      <li className="nav-item">
        <button
          className={`nav-link ${currentTab === "overview" ? "active" : ""}`}
          onClick={() => setCurrentTab("overview")}
        >
          Learners Overview
          {/* {I18n.t("views.achievements.common.badges")} */}
        </button>
      </li>

      <li className="nav-item">
        <button
          className={`nav-link ${currentTab === "progress" ? "active" : ""}`}
          onClick={() => setCurrentTab("progress")}
        >
          Learners Progress
          {/* {I18n.t("views.achievements.common.ranks")} */}
        </button>
      </li>
    </ul>
  );
};

export default LearnersTabs;
